import { editModeFns         } from "./EditMode";
import { createModeFns       } from "./CreateMode";
import { vehicleTypeModeFns  } from "./VehicleTypeMode";
import { vehicleColorModeFns } from "./VehicleColorMode";
import { inactiveModeFns } from "./InactiveMode";
import { DrawingState, DrawingStateFns, Mode } from "./ModeContext";
import { vehicleSegmentModeFns } from "./VehiclePartsMode";
import { vehicleExtrasModeFns } from "./VehicleExtrasMode";
import { parkingMode } from "./ParkingMode";

const fnsMap: Record<DrawingState["mode"], DrawingStateFns> = {
    [Mode.Inactive]:        inactiveModeFns, //not sure what to do here yet
    [Mode.Edit]:            editModeFns,
    [Mode.Create]:          createModeFns,
    [Mode.VehicleType]:     vehicleTypeModeFns,
    [Mode.VehicleColor]:    vehicleColorModeFns,    
    [Mode.VehicleParts]:    vehicleSegmentModeFns,
    [Mode.VehicleExtras]:   vehicleExtrasModeFns,
    [Mode.Parking]:         parkingMode,
};

export function getModeFns( mode: DrawingState ): DrawingStateFns {
    return fnsMap[mode.mode];
}